import { Address } from 'viem';

export const usdtERC20Addresss = process.env
  .NEXT_PUBLIC_USDT_ERC20_ADDRESS as Address;
export const usdtBEP20Addresss = process.env
  .NEXT_PUBLIC_USDT_BEP20_ADDRESS as Address;
export const paxgAddress = process.env.NEXT_PUBLIC_PAXG_ADDRESS as Address;
export const ethAddress = '0xtest' as Address;

// export const depositETHContractAddress = process.env
//   .NEXT_PUBLIC_DEPOSIT_ETH_CONTRACT as Address;

export const loanDepositETHContractAddress = process.env
  .NEXT_PUBLIC_LOAN_DEPOSIT_ETH_CONTRACT as Address;

export const tradeDepositETHContractAddress = process.env
  .NEXT_PUBLIC_TRADE_DEPOSIT_ETH_CONTRACT as Address;

export const tradeDepositBSCContractAddress = process.env
  .NEXT_PUBLIC_TRADE_DEPOSIT_BSC_CONTRACT as Address;
  
// export const depositBSCContractAddress = process.env
//   .NEXT_PUBLIC_DEPOSIT_BSC_CONTRACT as Address;

export const loanDepositBSCContractAddress = process.env
  .NEXT_PUBLIC_LOAN_DEPOSIT_BSC_CONTRACT as Address;

// export const claimContractAddress = process.env
//   .NEXT_PUBLIC_WITHDRAW_CONTRACT as Address;

// export const bscClaimContractAddress = process.env
//   .NEXT_PUBLIC_WITHDRAW_BSC_CONTRACT as Address;

export const tradeClaimContractAddress = process.env
  .NEXT_PUBLIC_TRADE_WITHRAW_ETH_CONTRACT as Address;

export const tradeBSCClaimContractAddress = process.env
  .NEXT_PUBLIC_TRADE_WITHRAW_BSC_CONTRACT as Address;
